/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AuthLoginProviderResponse { 
    action?: AuthLoginProviderResponse.ActionEnum;
    authorizationPath?: string;
}
export namespace AuthLoginProviderResponse {
    export const ActionEnum = {
        Redirect: 'REDIRECT',
        PasswordResetEmailSent: 'PASSWORD_RESET_EMAIL_SENT',
        AccountInactive: 'ACCOUNT_INACTIVE'
    } as const;
    export type ActionEnum = typeof ActionEnum[keyof typeof ActionEnum];
}


